import { useMemo } from "react";

type Props = {
  currentQuestion: any;
};

const GridField = ({ currentQuestion }: Props) => {
  const { properties } = currentQuestion;
  const gridConfig = properties?.gridConfig;

  const rowAggregate = useMemo(() => {
    return gridConfig?.rows?.some((row: any) => !!row.aggregateType);
  }, [gridConfig]);

  const columnAggregate = useMemo(() => {
    return gridConfig?.columns?.some((col: any) => !!col.aggregateType);
  }, [gridConfig]);

  return (
    <>
      {gridConfig?.fieldType === "row" && (
        <table style={{ maxWidth: "100%" }}>
          <thead>
            <tr>
              <td></td>
              {gridConfig?.columns.map((col: any, i: number) => (
                <td key={col.label + i}>{col.label || "Column " + (i + 1)}</td>
              ))}
              {rowAggregate && (
                <td style={{ textAlign: "center" }} key="row-aggregate">
                  Aggregate
                </td>
              )}
            </tr>
          </thead>
          <tbody>
            {gridConfig?.rows.map((row: any, i: number) => (
              <tr key={row.label + i}>
                <td>{row.label || "Row " + (i + 1)}</td>

                {gridConfig?.columns.map((_: any, j: number) => (
                  <td key={i + j}>
                    <input style={{ width: "100px", height: "35px" }} />
                  </td>
                ))}
                {rowAggregate && (
                  <td style={{ textAlign: "center" }}>
                    {row.aggregateType ? row.aggregateType : "-"}
                  </td>
                )}
              </tr>
            ))}
            {columnAggregate && (
              <tr key={"col-aggregate"}>
                <td style={{ textAlign: "center" }}>Aggregate</td>

                {gridConfig?.columns.map((item: any, j: number) => (
                  <td style={{ textAlign: "center" }} key={j}>
                    {item.aggregateType ? item.aggregateType : "-"}
                  </td>
                ))}

                {rowAggregate && <td></td>}
              </tr>
            )}
          </tbody>
        </table>
      )}

      {gridConfig?.fieldType === "column" && (
        <table style={{ maxWidth: "100%" }}>
          <thead>
            <tr>
              <td></td>
              {gridConfig?.columns.map((col: any, i: number) => (
                <td key={i}>{col.label || "Column " + (i + 1)}</td>
              ))}
              {rowAggregate && (
                <td key={"row-aggregate"} style={{ textAlign: "center" }}>
                  Aggregate
                </td>
              )}
            </tr>
          </thead>
          <tbody>
            {gridConfig?.rows.map((row: any, i: number) => (
              <tr key={i}>
                <td style={{ width: "100px" }}>
                  {row.label || "Row " + (i + 1)}
                </td>

                {gridConfig?.columns.map((col: any, j: number) => (
                  <td key={col.label + j}>
                    <input style={{ width: "100px", height: "35px" }} />
                  </td>
                ))}
                {rowAggregate && (
                  <td style={{ textAlign: "center" }}>
                    {row.aggregateType ? row.aggregateType : "-"}
                  </td>
                )}
              </tr>
            ))}
            {columnAggregate && (
              <tr key={"col-aggregate"}>
                <td style={{ textAlign: "center" }}>Aggregate</td>

                {gridConfig?.columns.map((item: any, j: number) => (
                  <td style={{ textAlign: "center" }} key={j}>
                    {item.aggregateType ? item.aggregateType : "-"}
                  </td>
                ))}

                {rowAggregate && <td></td>}
              </tr>
            )}
          </tbody>
        </table>
      )}
    </>
  );
};

export default GridField;
